import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { OPD_API_URL } from '../../properties/opd-url-properties';
import { MICROSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/web-services';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';

@Component({
  selector: 'app-physical-location-dialog',
  templateUrl: './physical-location-dialog.component.html',
  styleUrls: ['./physical-location-dialog.component.scss']
})
export class PhysicalLocationDialogComponent implements OnInit, OnDestroy {
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  private subscriptionList = new Subscription();
  protected _onDestroy = new Subject<void>();
  formPhysicalLocation :FormGroup;
  constructor(
    public dialogRef: MatDialogRef<PhysicalLocationDialogComponent>,
    private appBaseService: AppBaseService,
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formPhysicalLocation = this.formBuilder.group({
      wing: [''],
      block: [''],
      floor: [''],
      ward: [''],
      room: [''],
      bed: [''],
      bedCategory: ['']
    });
    this.getPhysicalLocation(this.data);
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptionList.unsubscribe();
  }

  /**
   * closing dialog
   */
  onClick() {
    this.dialogRef.close();
  }
/**
 * 
 * @param rowData 
 */
  getPhysicalLocation(rowData) {
    this.data = rowData;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.GET_PHYSICAL_LOCATION_BY_ID + this.data.id )
      .subscribe((response) => {
        if (response) {
          this.formPhysicalLocation.patchValue({
            wing: response ? response.wing : "",
            block: response ? response.block : "",
            floor: response ? response.floor : "",
            ward: response ? response.ward : "",
            room: response ? response.room : "",
            bed: response ? response.bed : "",
            bedCategory: response ? response.bedCategory : ""
          });
        }
      });
  }
}
